var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Center, useSlotRecipe } from "@chakra-ui/react";
import { Header } from "@/components/Header";
import { SearchFormChildren } from "@/components/SearchForm";
import { TopBanner } from "@/components/TopBanner";
import { SearchForm } from "@/components/cortex";
export function Top(_a) {
    var modules = _a.modules;
    var recipe = useSlotRecipe({ key: "Top" });
    var recipeProps = recipe.splitVariantProps({})[0];
    var styles = recipe(recipeProps);
    var setTopHeightFromElementHeight = function (node) {
        if (!node)
            return;
        var resizeObserver = new ResizeObserver(function () {
            document.documentElement.style.setProperty("--top-height", "".concat(node.clientHeight, "px"));
        });
        resizeObserver.observe(node);
    };
    return (_jsxs(Box, __assign({ ref: setTopHeightFromElementHeight, css: styles.stickyTop }, { children: [modules.topBanner && _jsx(TopBanner, {}), modules.header && _jsx(Header, {}), _jsx(Center, __assign({ css: styles.searchFormBackgroundWrapper }, { children: _jsx(Box, __assign({ css: styles.searchFormWrapper }, { children: _jsx(SearchForm, { children: _jsx(SearchFormChildren, { modules: modules }) }) })) }))] })));
}
